import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice de coût de carburant - Calculez la consommation d'essence";
const DESCRIPTION =
  "Calculatrice de coût de carburant - Calculez la consommation d'essence. Outil financier en francais pour obtenir un calcul rapide, clair et exploitable pour vos decisions de budget, prix et rentabilite.";
const KEYWORDS =
  "coût carburant consommation d essence, calculatrice financiere, budget, rentabilite, marge, gestion des couts, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/fuel-cost-calculator";
function FuelCostCalculator() {
  const [distance, setDistance] = useState("");
  const [fuelEfficiency, setFuelEfficiency] = useState("");
  const [fuelPrice, setFuelPrice] = useState("");
  const [unitDistance, setUnitDistance] = useState("miles");
  const [unitEfficiency, setUnitEfficiency] = useState("mpg");
  const [unitPrice, setUnitPrice] = useState("per gallon");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  const calculateFuelCost = () => {
    if (!distance || !fuelEfficiency || !fuelPrice) {
      setError("Veuillez entrer toutes les valeurs correctement");
      setResult("");
      return;
    }
    let distanceInMiles = parseFloat(distance);
    let efficiencyInMpg = parseFloat(fuelEfficiency);
    let pricePerGallon = parseFloat(fuelPrice);
    if (unitDistance === "km") {
      distanceInMiles = distanceInMiles * 0.621371;
    }
    if (unitEfficiency === "liters per 100 km") {
      efficiencyInMpg = 235.214583 / efficiencyInMpg;
    } else if (unitEfficiency === "kilometers per liter") {
      efficiencyInMpg = efficiencyInMpg * 2.35214583;
    } else if (unitEfficiency === "liter per mile") {
      efficiencyInMpg = 1 / (efficiencyInMpg * 0.264172);
    }
    if (unitPrice === "per liter") {
      pricePerGallon = pricePerGallon * 3.78541;
    }
    const gallonsRequired = distanceInMiles / efficiencyInMpg;
    const cost = gallonsRequired * pricePerGallon;
    setResult({
      gallonsRequired: gallonsRequired.toFixed(2),
      cost: cost.toFixed(2),
    });
    setError("");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Bienvenue dans la calculatrice de coût de carburant! Cet outil merveilleux vous aide à
                  calculer la quantité de carburant requise et son coût avec précision pour différents
                  trajets. Que vous planifiiez un long voyage à travers le pays ou un court trajet, la
                  calculatrice de coût de carburant vous fournit les informations dont vous avez besoin
                  pour planifier votre budget efficacement. Avec cet outil, vous pouvez facilement
                  connaître le coût total du carburant en fonction de la distance, de l'efficacité
                  énergétique et du prix actuel du carburant.
                </p>
                <p>Pour utiliser efficacement la calculatrice:</p>
                <ul>
                  <li>
                    Entrez la distance que vous envisagez de parcourir, l'efficacité énergétique
                    (km/l), et le prix du carburant par unité.
                  </li>
                  <li>Choisissez les unités appropriées pour chaque valeur pour assurer la précision.</li>
                  <li>
                    Cliquez sur le bouton "Calculer" pour obtenir une estimation précise du coût du
                    carburant.
                  </li>
                  <li>
                    Le résultat apparaîtra sous le formulaire, facilitant la planification de votre trajet.
                  </li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label ms-2">Distance du trajet</label>
                    </b>
                    <input
                      type="number"
                      value={distance}
                      onChange={(e) => setDistance(e.target.value)}
                      className="form-control"
                      placeholder="Entrez la distance"
                      style={{ width: "75%", marginRight: "10px" }}
                    />
                    <select
                      value={unitDistance}
                      onChange={(e) => setUnitDistance(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="miles">Milles</option>
                      <option value="km">km</option>
                    </select>
                  </div>
                  <div className="form-group d-flex align-items-center mt-2">
                    <b>
                      <label className="form-label ms-2">Efficacité énergétique</label>
                    </b>
                    <input
                      type="number"
                      value={fuelEfficiency}
                      onChange={(e) => setFuelEfficiency(e.target.value)}
                      className="form-control"
                      placeholder="Entrez l'efficacité"
                      style={{ width: "75%", marginRight: "10px" }}
                    />
                    <select
                      value={unitEfficiency}
                      onChange={(e) => setUnitEfficiency(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="mpg">Milles par gallon</option>
                      <option value="liters per 100 km">Litres par 100 km</option>
                      <option value="kilometers per liter">km par litre</option>
                      <option value="liter per mile">Litre par mille</option>
                    </select>
                  </div>
                  <div className="form-group d-flex align-items-center mt-2">
                    <b>
                      <label className="form-label ms-2">Prix du carburant</label>
                    </b>
                    <input
                      type="number"
                      value={fuelPrice}
                      onChange={(e) => setFuelPrice(e.target.value)}
                      className="form-control"
                      placeholder="Entrez le prix"
                      style={{ width: "75%", marginRight: "10px" }}
                    />
                    <select
                      value={unitPrice}
                      onChange={(e) => setUnitPrice(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="per gallon">Par gallon</option>
                      <option value="per liter">Par litre</option>
                    </select>
                  </div>
                  <br />
                  <p className="alert alert-info">
                    <b>Efficacité énergétique: </b>
                    C'est le nombre de kilomètres que votre voiture parcourt avec un litre de carburant.
                    Vous pouvez le trouver dans le manuel de la voiture, sur le tableau de bord, ou le
                    calculer vous-même.
                  </p>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateFuelCost}
                  >
                    Calculer                  </button>
                </div>
                <br />
                <div>
                  { error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      Erreur: {error}
                    </p>
                  ) : (
                    <>
                      { result && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <h4>Résultats :</h4>
                          <p>Carburant requis: {result.gallonsRequired} gallons</p>
                          <p>Coût total: {result.cost} EUR</p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Les facteurs affectant la consommation de carburant
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                De nombreux facteurs peuvent affecter la consommation de carburant, 
                notamment:
              </p>
              <ul>
                <li><strong>Type de véhicule :</strong> Les voitures plus grandes et 
                plus lourdes consomment généralement plus de carburant</li>
                <li><strong>Vitesse de conduite :</strong> Une vitesse excessive augmente 
                la consommation de carburant</li>
                <li><strong>Conditions routières :</strong> Les routes en montée et les 
                embouteillages augmentent la consommation</li>
                <li><strong>Pression des pneus :</strong> Des pneus sous-gonflés augmentent 
                la consommation de carburant</li>
                <li><strong>État du moteur :</strong> Un moteur mal entretenu consomme plus 
                de carburant</li>
                <li><strong>Charge du véhicule :</strong> Plus le poids du véhicule est 
                important, plus la consommation augmente</li>
                <li><strong>État de la climatisation :</strong> L'utilisation de la 
                climatisation augmente la consommation de carburant</li>
              </ul>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>Conseils pour économiser le carburant</h3>
            </div>
            <div className="info-section-body">
              <p>Il existe plusieurs façons d'économiser le carburant, notamment:</p>
              <ul>
                <li><strong>Conduite écologique :</strong> Conduisez en douceur, en évitant 
                les brusques accélérations et freinages</li>
                <li><strong>Respectez les limites de vitesse :</strong> Une vitesse constante 
                et modérée réduit la consommation</li>
                <li><strong>Vérifiez la pression des pneus :</strong> Maintenez-les à la 
                pression recommandée par le fabricant</li>
                <li><strong>Entretien régulier du véhicule :</strong> Un véhicule bien 
                entretenu consomme moins de carburant</li>
                <li><strong>Choisissez le bon carburant :</strong> Utilisez le type de 
                carburant recommandé pour votre véhicule</li>
                <li><strong>Débarrassez-vous des charges inutiles :</strong> Moins de poids 
                = moins de consommation</li>
                <li><strong>Éteignez le moteur :</strong> Si vous attendez longtemps, 
                éteignez le moteur plutôt que de le laisser tourner</li>
                <li><strong>Utilisez le régulateur de vitesse :</strong> Sur l'autoroute, 
                cela aide à maintenir une vitesse stable</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default FuelCostCalculator;
